<div class="container-fluid admin-page driver-page orders-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'Driver details' | translate }}</h1>
            <p>{{ 'Review the driver profile and the orders assigned to the current car or driver.' | translate }}</p>
        </div>
        <div class="admin-header-actions">
            <button (click)="refresh()" [disabled]="isLoadingDriver || isLoadingOrders"
                    class="admin-refresh-button" type="button">
                <i [class.spinning]="isLoadingDriver || isLoadingOrders" class="material-icons">refresh</i>
                <span>{{ 'Refresh' | translate }}</span>
            </button>
        </div>
    </header>

    @if (driverIdentifier === '') {
        <div class="state-card admin-page-state empty-state">
            <i class="material-icons">person_search</i>
            <span>{{ 'Select a driver to view orders.' | translate }}</span>
    </div>
    }

    @if (driver) {
        <div class="driver-header">
            <div class="driver-avatar">
                <img [alt]="driver.DriverName || ('Driver' | translate)" class="img rounded"
                     onerror="this.onerror=null;this.src='assets/images/no_image.png'"
                     src="{{baseUrlForImages}}{{driver.DriverPicture}}">
            </div>
            <div class="driver-summary">
                <span class="section-label">{{ 'Driver' | translate }}</span>
                <h2>{{ driver.DriverName }}</h2>
                <div class="driver-meta">
                    @if (driver.DriverPhone) {
                        <span><i class="material-icons">phone</i>{{ driver.DriverPhone }}</span>
                    }
                    <span><i class="material-icons">directions_car</i>{{ getCurrentCarDisplay() }}</span>
                    @if (car.CarNumber) {
                        <span><i class="material-icons">confirmation_number</i>{{ car.CarNumber }}</span>
                    }
                </div>
            </div>
    </div>
    }

    @if (car) {
        <div class="driver-orders-toolbar orders-toolbar admin-toolbar">
            <div class="car-filter-summary">
                <span>{{ 'Orders filtered by car and driver' | translate }}</span>
                <strong>{{ getCurrentCarDisplay() }}</strong>
            </div>
            <label class="page-size admin-page-size">
                <span>{{ 'Rows' | translate }}</span>
                <select (change)="changePageSize()" [(ngModel)]="pageSize" [disabled]="isLoadingOrders">
                    <option [ngValue]="10">10</option>
                    <option [ngValue]="25">25</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>
                </select>
            </label>
    </div>
    }

    @if (isLoadingDriver || isLoadingOrders) {
        <div class="state-card admin-page-state">
            <i class="material-icons spinning">refresh</i><span>{{ 'Loading orders...' | translate }}</span>
    </div>
    }
    @if (!isLoadingDriver && !isLoadingOrders && loadError !== '') {
        <div
                class="state-card admin-page-state error-state">
            <i class="material-icons">error_outline</i><span>{{ loadError | translate }}</span>
            <button (click)="refresh()" type="button">{{ 'Try again' | translate }}</button>
    </div>
    }

    @if (!isLoadingDriver && !isLoadingOrders && loadError === '' && car) {
        @if (orders.length > 0) {
            <div class="orders-table-wrap admin-data-table-wrap">
                <table class="orders-table admin-data-table">
                    <thead>
                    <tr>
                        <th [attr.aria-sort]="tableSort.getAriaSort('date')">
                            <button (click)="tableSort.toggle('date')" class="admin-sort-button" type="button">
                                <span>{{ 'Date' | translate }}</span><span class="admin-sort-indicator">
                  <i [class.active]="tableSort.isDirection('date', 'asc')" class="material-icons">arrow_drop_up</i>
                  <i [class.active]="tableSort.isDirection('date', 'desc')" class="material-icons">arrow_drop_down</i>
                </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('source')">
                            <button (click)="tableSort.toggle('source')" class="admin-sort-button" type="button">
                                <span>{{ 'Source' | translate }}</span><span class="admin-sort-indicator">
                <i [class.active]="tableSort.isDirection('source', 'asc')" class="material-icons">arrow_drop_up</i>
                <i [class.active]="tableSort.isDirection('source', 'desc')" class="material-icons">arrow_drop_down</i>
              </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('client')">
                            <button (click)="tableSort.toggle('client')" class="admin-sort-button" type="button">
                                <span>{{ 'Client' | translate }}</span><span class="admin-sort-indicator">
              <i [class.active]="tableSort.isDirection('client', 'asc')" class="material-icons">arrow_drop_up</i>
              <i [class.active]="tableSort.isDirection('client', 'desc')" class="material-icons">arrow_drop_down</i>
            </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('phone')">
                            <button (click)="tableSort.toggle('phone')" class="admin-sort-button" type="button">
                                <span>{{ 'Phone' | translate }}</span><span class="admin-sort-indicator">
            <i [class.active]="tableSort.isDirection('phone', 'asc')" class="material-icons">arrow_drop_up</i>
            <i [class.active]="tableSort.isDirection('phone', 'desc')" class="material-icons">arrow_drop_down</i>
          </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('pickup')">
                            <button (click)="tableSort.toggle('pickup')" class="admin-sort-button" type="button">
                                <span>{{ 'Pickup' | translate }}</span><span class="admin-sort-indicator">
          <i [class.active]="tableSort.isDirection('pickup', 'asc')" class="material-icons">arrow_drop_up</i>
          <i [class.active]="tableSort.isDirection('pickup', 'desc')" class="material-icons">arrow_drop_down</i>
        </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('car')">
                            <button (click)="tableSort.toggle('car')" class="admin-sort-button" type="button">
                                <span>{{ 'Car' | translate }}</span><span class="admin-sort-indicator">
        <i [class.active]="tableSort.isDirection('car', 'asc')" class="material-icons">arrow_drop_up</i>
        <i [class.active]="tableSort.isDirection('car', 'desc')" class="material-icons">arrow_drop_down</i>
      </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('status')">
                            <button (click)="tableSort.toggle('status')" class="admin-sort-button" type="button">
                                <span>{{ 'Status' | translate }}</span><span class="admin-sort-indicator">
      <i [class.active]="tableSort.isDirection('status', 'asc')" class="material-icons">arrow_drop_up</i>
      <i [class.active]="tableSort.isDirection('status', 'desc')" class="material-icons">arrow_drop_down</i>
    </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('price')">
                            <button (click)="tableSort.toggle('price')" class="admin-sort-button" type="button">
                                <span>{{ 'Price' | translate }}</span><span class="admin-sort-indicator">
    <i [class.active]="tableSort.isDirection('price', 'asc')" class="material-icons">arrow_drop_up</i>
    <i [class.active]="tableSort.isDirection('price', 'desc')" class="material-icons">arrow_drop_down</i>
  </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('paymentMethod')">
                            <button (click)="tableSort.toggle('paymentMethod')" class="admin-sort-button" type="button">
                                <span>{{ 'Payment method' | translate }}</span><span class="admin-sort-indicator">
    <i [class.active]="tableSort.isDirection('paymentMethod', 'asc')"
       class="material-icons">arrow_drop_up</i>
    <i [class.active]="tableSort.isDirection('paymentMethod', 'desc')"
       class="material-icons">arrow_drop_down</i>
  </span>
                            </button>
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                        @for (order of getSortedOrders(); track order) {
                            <tr (click)="openOrderDetails(order)" (keydown.enter)="openOrderDetails(order)"
                                class="order-row" tabindex="0">
                                <td [attr.data-label]="'Date' | translate">{{ getEntryDate(order) | date:'dd.MM.yyyy HH:mm' }}</td>
                                <td [attr.data-label]="'Source' | translate">{{ getOrderSource(order) | translate }}</td>
                                <td [attr.data-label]="'Client' | translate">{{ getClientName(order) }}</td>
                                <td [attr.data-label]="'Phone' | translate">{{ getClientPhone(order) }}</td>
                                <td [attr.data-label]="'Pickup' | translate"
                                    class="address-cell">{{ formatAddress(getPickupAddress(order)) }}
                                </td>
                                <td [attr.data-label]="'Car' | translate">{{ getCarDisplay(order) }}</td>
                                <td [attr.data-label]="'Status' | translate"><span
                                        [appOrderStatus]="getOrderStatus(order)"
                                        class="status-pill">{{ getOrderStatus(order) | translate }}</span>
                                </td>
                                <td [attr.data-label]="'Price' | translate">{{ getPrice(order) }}</td>
                                <td [attr.data-label]="'Payment method' | translate">{{ getPaymentMethod(order) | translate }}</td>
                                <td class="details-cell">
                                    <button (click)="openOrderDetails(order); $event.stopPropagation()"
                                            [attr.aria-label]="'Open order details' | translate" class="details-button"
                                            type="button">
                                        <i class="material-icons">chevron_right</i>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        @if (orders.length === 0) {
            <div class="state-card admin-page-state empty-state">
                <i class="material-icons">receipt</i><span>{{ 'No orders were found for this car or driver.' | translate }}</span>
            </div>
        }
        @if (totalCount > 0) {
            <footer class="pagination admin-pagination">
    <span class="pagination-summary admin-pagination-summary">{{ getFirstItemNumber() }}
        –{{ getLastItemNumber() }} {{ 'of' | translate }} {{ totalCount }}</span>
                <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" [disabled]="isLoadingOrders"
                                label="Driver order pages" (pageChange)="goToPage($event)"></app-pagination>
            </footer>
        }
    }
</div>

<app-order-details (closed)="closeOrderDetails()" [order]="selectedOrder"></app-order-details>
